import React from 'react';
import subscriptions from '../data/subscriptions';

export default function Subscriptions() {
  return (
    <section className="py-10 bg-jasmine-white border-y border-[#e7e3cf] mb-12">
      <div className="max-w-[1440px] mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <div className="flex items-center justify-center gap-3 mb-3">
            <div className="flex items-center gap-1 px-3 py-0.5 bg-white border border-festive-orange/10 rounded-full shadow-sm">
              <span className="material-symbols-outlined text-festive-orange !text-xs">verified</span>
              <span className="text-[9px] font-bold uppercase tracking-wider text-[#4a4736]">Fresh Every Morning</span>
            </div>
            <div className="flex items-center gap-1 px-3 py-0.5 bg-white border border-festive-orange/10 rounded-full shadow-sm">
              <span className="material-symbols-outlined text-festive-orange !text-xs">event_busy</span>
              <span className="text-[9px] font-bold uppercase tracking-wider text-[#4a4736]">Cancel Anytime</span>
            </div>
          </div>
          <h2 className="text-2xl md:text-3xl font-black text-[#1b190d] mb-2 tracking-tight">
            Flower Subscriptions –
            <span className="text-festive-orange">Fresh Flowers, Delivered Daily</span>
          </h2>
          <p className="text-base text-[#9a8d4c] font-medium max-w-xl mx-auto leading-tight">
            Daily and weekly flower subscriptions for your pooja and temple needs
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto mb-12 items-stretch">
          {subscriptions.map((plan) => (
            <div key={plan.id} className={`bg-white rounded-2xl p-6 border ${plan.badge ? 'border-2 border-festive-orange shadow-xl transform md:scale-105 z-10' : 'border border-[#e7e3cf] shadow-sm hover:shadow-md'} transition-all flex flex-col relative overflow-hidden`}>
              {plan.badge && (
                <div className="absolute top-0 right-0 bg-festive-orange text-white px-4 py-1 rounded-bl-xl font-bold text-[10px] uppercase tracking-widest">{plan.badge}</div>
              )}
              <div className="mb-4">
                <h3 className="text-xl font-bold text-[#1b190d] mb-1">{plan.title}</h3>
                <p className="text-[#9a8d4c] text-xs">{plan.badge ? 'Daily flowers + 1 small garland weekly.' : plan.title === 'Basic Puja Plan' ? 'Essential daily flowers.' : 'Complete kit for special occasions.'}</p>
              </div>
              <div className="mb-6">
                <div className="flex items-baseline gap-1">
                  <span className="text-3xl font-black text-[#1b190d]">{plan.price}</span>
                  <span className="text-[#9a8d4c] font-bold text-sm">{plan.period}</span>
                </div>
              </div>
              <ul className="space-y-3 mb-8 flex-1">
                {plan.features.map((f, i) => (
                  <li key={i} className="flex items-center gap-2 text-xs font-semibold text-[#4a4736]">
                    <span className="material-symbols-outlined text-green-600 !text-lg">check_circle</span>
                    {f}
                  </li>
                ))}
              </ul>
              <button className={`w-full py-3 rounded-lg ${plan.badge ? 'bg-festive-orange text-white hover:bg-[#e65b00] shadow-md shadow-festive-orange/20' : 'border-2 border-festive-orange/30 text-festive-orange hover:bg-festive-orange hover:text-white hover:border-festive-orange'} font-bold text-sm transition-all`}> 
                {plan.badge ? 'Subscribe Now' : plan.title === 'Basic Puja Plan' ? 'Start Subscription' : 'Start Subscription'}
              </button>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 border-t border-[#e7e3cf] pt-8">
          <div className="flex flex-col items-center text-center px-4">
            <div className="size-10 rounded-full bg-festive-orange/10 flex items-center justify-center text-festive-orange mb-3">
              <span className="material-symbols-outlined text-xl">autorenew</span>
            </div>
            <h4 className="font-bold text-sm text-[#1b190d] mb-0.5">No daily re-ordering</h4>
            <p className="text-[10px] text-[#9a8d4c]">Set it once and enjoy continuous service</p>
          </div>
          <div className="flex flex-col items-center text-center px-4">
            <div className="size-10 rounded-full bg-festive-orange/10 flex items-center justify-center text-festive-orange mb-3">
              <span className="material-symbols-outlined text-xl">wb_sunny</span>
            </div>
            <h4 className="font-bold text-sm text-[#1b190d] mb-0.5">Early morning delivery</h4>
            <p className="text-[10px] text-[#9a8d4c]">Flowers reach you before your first ritual</p>
          </div>
          <div className="flex flex-col items-center text-center px-4">
            <div className="size-10 rounded-full bg-festive-orange/10 flex items-center justify-center text-festive-orange mb-3">
              <span className="material-symbols-outlined text-xl">priority_high</span>
            </div>
            <h4 className="font-bold text-sm text-[#1b190d] mb-0.5">Priority on festival days</h4>
            <p className="text-[10px] text-[#9a8d4c]">Guaranteed stock during high-demand festivals</p>
          </div>
        </div>

        <div className="text-center mt-10">
          <p className="text-[#4a4736] font-bold text-xs tracking-wide bg-white inline-block px-5 py-2 rounded-full border border-[#e7e3cf] shadow-sm">Predictable monthly cost. Peace of mind for your family.</p>
        </div>
      </div>
    </section>
  );
}
